import type React from "react";
import { getColor, type Props } from "~/components/icons/helper";

export const ExclamationMarkIcon: React.FC<Props> = ({ color }) => {
	const stroke = getColor(color);
	return (
		<svg
			role="img"
			aria-label="Exclamation Mark"
			width="7"
			height="24"
			viewBox="0 0 7 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle cx="3.5" cy="20.5" r="3" stroke={stroke} />
			<rect x="0.5" y="0.5" width="6" height="15" rx="1.5" stroke={stroke} />
		</svg>
	);
};
